import { api } from './api';

const ReportsAPI = {
  getDetentionReport: (startDate, endDate, bookingNumber) =>
    api.get('/reports/detention', {
      params: { startDate, endDate, bookingNumber },
    }),
  getDwellTimeReport: (startDate, endDate) =>
    api.get('/reports/line-container-empty-free-days', {
      params: { startDate, endDate },
    }),
  getCompletedVoyageReport: (startDate, endDate) =>
    api.get('reports/completed-voyage', {
      params: { startDate, endDate },
    }),
};

export default ReportsAPI;